module.exports = __webpack_public_path__ + "static/media/numpy.7dda86e6.svg";